if (!customElements.get('luminails-cart-recommendations')) {
  customElements.define(
    'luminails-cart-recommendations',
    class LuminailsCartRecommendations extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleClick);
        this.addEventListener('change', this.handleVariantChange);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('change', this.handleVariantChange);
      }

      handleVariantChange = (event) => {
        if (!event.target.matches('.luminails-cart-recommendation__select')) return;

        const selectedOption = event.target.options[event.target.selectedIndex];
        const card = event.target.closest('.luminails-cart-recommendation');
        const price = card?.querySelector('.luminails-cart-recommendation__price');

        if (price && selectedOption.dataset.price) price.textContent = selectedOption.dataset.price;
      };

      handleClick = async (event) => {
        const button = event.target.closest('.luminails-cart-recommendation__add');
        if (!button || !this.contains(button) || button.disabled) return;

        const card = button.closest('.luminails-cart-recommendation');
        const select = card.querySelector('.luminails-cart-recommendation__select');
        const variantId = select?.value || card.dataset.defaultVariantId;
        const error = card.querySelector('.luminails-cart-recommendation__error');
        const cartDrawer = document.querySelector('cart-drawer');

        if (!variantId || !cartDrawer) return;

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.classList.add('loading');
        error.hidden = true;

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append(
          'sections',
          cartDrawer.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        try {
          const response = await fetch(routes.cart_add_url, config);
          const state = await response.json();

          if (!response.ok || state.status) {
            throw new Error(state.description || state.message || window.cartStrings.error);
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'luminails-cart-recommendations',
            productVariantId: variantId,
            cartData: state,
          });
          cartDrawer.renderContents(state);
        } catch (addError) {
          error.textContent = addError.message || window.cartStrings.error;
          error.hidden = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.classList.remove('loading');
        }
      };
    }
  );
}
